import { QuoteData } from "src/model/api/quote-data.model";

export const getExtraInfo = (quote: QuoteData) => {
  return [
    {
      key: "cname",
      content: quote.company_name
        ? quote.company_name
        : `${quote.first_name || ""} ${
            quote.last_name || ""
          }`.trim(),
      bold: true,
    },
    {
      key: "street_address",
      content: (quote.street_address || "").trim(),
    },
    {
      key: "city",
      content: `${quote.zipcode || ""} ${quote.city || ""}`.trim(),
    },
    {
      key: "country",
      content: (quote.country || "").trim(),
    },
    {
      key: "email",
      content: quote.email || "",
    },
    {
      key: "tele",
      content: quote.telephone || "",
    },
    {
      key: "tax",
      content: quote.tax_number || "",
    },
  ].filter(
    (extra) => typeof extra.content === "string" && extra.content.length > 0
  );
};
